import React from 'react'
import { BrowserRouter as Router, Route } from 'react-router-dom'

import Header from './Header'
import Home from '../pages/Home'
import About from '../pages/About'
import AnotherPage from '../pages/AnotherPage'
import FaqTopic from './FaqTopic'
import Faq from '../pages/Faq'

const App = () => (
  <Router>
    <div>
      <Header />
      <main>
        <Route exact path='/' component={Home} />
        <Route path='/about' component={About} />
        <Route path='/another-page' component={AnotherPage} />
        <Route path='/faq-topic/:slug' component={FaqTopic} />
        <Route path='/faq' component={Faq} />
      </main>
    </div>
  </Router>
)

export default App



// WEBPACK FOOTER //
// ./src/components/App.js